import { render, staticRenderFns } from "./BlockUserApiReport.vue?vue&type=template&id=811c08c0"
import script from "./BlockUserApiReport.vue?vue&type=script&lang=js"
export * from "./BlockUserApiReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports